// Custom Javascript events used for coordinating between components that add/remove items from Lists
export let ListEvents = /*#__PURE__*/function (ListEvents) {
  ListEvents["ADD"] = "addToList";
  ListEvents["REMOVE"] = "removeFromList";
  ListEvents["CREATE"] = "createNewList";
  return ListEvents;
}({});
export const MAX_TITLE_CHARACTER_LIMIT = 60;
export const MIN_TITLE_CHARACTER_LIMIT = 1;
//# sourceMappingURL=constants.js.map